

export default function LogsAcesso(){
    return (<>Logs Acesso</>)
} 